// gapi (google api) initialization
export const GAPI_INIT_TRIGGER = "GAPI_INIT_TRIGGER";
export const GAPI_INIT_SUCCESS = "GAPI_INIT_SUCCESS";
export const GAPI_INIT_ERROR = "GAPI_INIT_ERROR";

// get data from sheets
export const SHEET_DATA_QUERY_TRIGGER = "SHEET_DATA_QUERY_TRIGGER";
export const SHEET_DATA_QUERY_SUCCESS = "SHEET_DATA_QUERY_SUCCESS";
export const SHEET_DATA_QUERY_ERROR = "SHEET_DATA_QUERY_ERROR";
